<template>
  <div class="postView">
    <div style="position:sticky; top:-0px;z-index: 99;background: #fff;">
      <div v-if="sectionName" class="head">
        {{ sectionName }}
        <span><img @click="returnBack" src="../../assets/img/fffIcon.png" alt="" /></span>
      </div>
      <div v-if="topic" class="label">标题：<span v-html="topic"></span></div>
    </div>
    <van-list v-model="loading" :finished="finished" :finished-text="list.length ? '没有更多了' : ''" @load="onLoad">
      <div v-for="(item, index) in list" :key="index" class="section">
        <div class="infos">
          <div class="s1">
            <div class="t">
              <img class="tx" :src="item.author.face" alt="" />
              <div class="name">{{ item.author.name }}</div>
              <img class="xj" :src="item.author.skin" alt="" />
            </div>
            <div class="rbtn">
              <div @click="reply">回复 &nbsp;|</div>
              <div @click="lifeBuoy()">救生圈 |</div>
              <div @click="handleScore(item)">评分 |</div>
              <div @click="handleScoreList(item)">查看 |</div>
              <!-- <div @click="thePoster">只看楼主 |</div> -->
              <!--              <div @click="sort">{{ isSort ? '倒序' : '正序' }} |</div>-->
              <div @click="callPhone(item.authInfo)">电话</div>
            </div>
          </div>
          <p @click="back" style="font-size:14px;color:red;position: relative;">
            本贴内容来源于一尘网，点击此处访问原网址
            <span v-if="item.layer == 1" class="layer">楼主</span>
            <span v-else class="layer">第<span style="color:red"> {{ item.layer }} </span>楼</span>
          </p>
          <div class="s2">
            <div class="row">
              <div style="flex: 1.5;" class="f">
                <span class="slabel">交易等级:</span>
                <span class="cdesc">{{ item.author.tradeGrade }}</span>
              </div>
              <div class="f">
                <span class="slabel">信用积分:</span>
                {{ item.author.creditScore }}
              </div>
              <div class="f">
                <span class="slabel">评分次数:</span>
                {{ item.author.ratingCount }}
              </div>
            </div>
            <div class="row">
              <div style="flex: 1.5;" class="f">
                <span class="slabel">发帖次数:</span>
                {{ item.author.postCount }}
              </div>
              <div class="f">
                <span class="slabel">浏览次数:</span>
                {{ viewinfos.readCount }}
              </div>
              <div class="f">
                <span class="slabel">回复次数:</span>
                {{ viewinfos.replyCount }}
              </div>
            </div>
            <div class="row">
              <div style="flex: 1.5;" class="f">
                <span class="slabel">发帖时间:</span>
                {{ item.stamp }}
              </div>
            </div>
          </div>
        </div>
        <div 
           class="downLoadApp">
          公众号：一尘盯盘助手
          <!-- <img class="dlIMG" src="../../assets/img/downloadApp.png" alt="" /> -->
        </div>
        <div class="html">
          <div id="htmlcontent" class="htmlcontent" v-html="item.content"></div>
          <img class="sigline" src="../../assets/face/sigline.png" alt="" />

          <div style="position: relative;">
            <div class="desc" :class="item.toggleShow ? 'hideDescbox' : ''" v-html="item.authInfo"></div>
            <div @click="toggleClick(item)" class="toggleBtn">
              {{ item.toggleShow ? '收起' : '展开' }}
            </div>
          </div>
        </div>
        <div class="storey">
          <!-- <div><img class="ip" src="../../assets/face/ip.png" alt="" />{{ item.stamp }}</div> -->
          <!-- <div>
            <img class="top" src="../../assets/face/top.png" alt="" />
            {{ item.layer == 1 ? '楼主' : '第' + item.layer + '楼' }}
          </div> -->
        </div>
      </div>
    </van-list>
    <van-popup v-model="lifeBuoyShow">
      <div class="lifebuoyBox">
        <div class="head">道具使用列表</div>
        <div class="content">
          <div @click="checkedCard(14)" class="card">
            <img src="../../assets/face/bigx.png" alt="" />
            <div class="checked">
              <div class="labelnum">
                数量：{{ isLifeBuoyShowFetch ? lifeBuoyInfos.bigLifeRingAmount : '获取中' }}
              </div>
              <van-checkbox v-model="bigqchecked" checked-color="red"></van-checkbox>
            </div>
          </div>
          <div @click="checkedCard(13)" class="card">
            <img src="../../assets/face/smx.png" alt="" />
            <div class="checked">
              <div class="labelnum">
                数量：{{ isLifeBuoyShowFetch ? lifeBuoyInfos.lifeRingAmount : '获取中' }}
              </div>
              <van-checkbox v-model="smallqchecked" checked-color="red"></van-checkbox>
            </div>
          </div>
        </div>
        <div v-if="bigqchecked" class="bottomtip">说明：【大救生圈】可将帖子固顶12小时。</div>
        <div v-if="smallqchecked" class="bottomtip">说明：【救生圈】可将帖子固顶6小时。</div>
        <div class="btnsave">
          <van-button :disabled="!isLifeBuoyShowFetch && isdisabled" block @click="save">立即使用</van-button>
        </div>
      </div>
    </van-popup>

    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>
<script>
import { dumpPost, queryProps, useProps, getSectionList } from '@/api/base';
import { asyncIsVip } from '@/utils/isVip';
import { shareformatDateTime, cardType, IsPC } from '@/utils/index';
import { ImagePreview } from 'vant';

export default {
  data() {
    return {
      list: [],
      content: null,
      lifeBuoyShow: false,
      isLifeBuoyShowFetch: false,
      isdisabled: false,
      url: null,
      bigqchecked: false,
      smallqchecked: true,
      checkedCardNum: 13,
      lifeBuoyInfos: { bigLifeRingAmount: 0, lifeRingAmount: 0 },
      sectionName: null,
      isVip: false,
      viewinfos: {
        readCount: null,
        replyCount: null,
      },
      isSort: true,
      topic: null,
      page: 1,
      loading: false,
      finished: false,
      allPage: 1,
      show: false,
      actions: [],
      sectionCode: '',
    };
  },
  created() {
    this.url = decodeURIComponent(decodeURIComponent(this.$route.query.href));
    this.getPlateinfos();
  },

  methods: {
    shareformatDateTime,
    cardType,
    IsPC,
    handleDownloadApp() {
      window.location.href = 'https://h5.yichenbao.cn/#/pagesB/dowloadApp/index';
    },
    // 为内容中的图片添加点击预览功能
    addImagePreview() {
      this.$nextTick(() => {
        // 获取所有 htmlcontent 容器
        const containers = document.querySelectorAll('.htmlcontent');

        containers.forEach(container => {
          // 获取当前容器内的所有图片
          const images = container.querySelectorAll('img');

          // 收集所有非 gif 图片的 src
          const imageSrcs = [];
          images.forEach(img => {
            const src = img.getAttribute('src');
            // 排除 gif 图片
            if (src && src.indexOf('gif') === -1) {
              imageSrcs.push(src);

              // 避免重复添加事件
              if (!img.dataset.previewAdded) {
                img.dataset.previewAdded = 'true';

                // 为每张图片添加点击事件
                img.style.cursor = 'pointer';
                img.onclick = (event) => {
                  // 阻止默认行为（防止 a 标签跳转）
                  event.preventDefault();
                  // 阻止事件冒泡
                  event.stopPropagation();

                  // 找到当前点击图片的索引
                  const startPosition = imageSrcs.indexOf(src);

                  // 打开图片预览
                  ImagePreview({
                    images: imageSrcs,
                    startPosition: startPosition >= 0 ? startPosition : 0,
                    closeable: true,
                  });
                };

                // 如果图片的父元素是 a 标签，也阻止其默认行为
                const parentLink = img.closest('a');
                if (parentLink && !parentLink.dataset.preventDefault) {
                  parentLink.dataset.preventDefault = 'true';
                  parentLink.onclick = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                  };
                }
              }
            }
          });
        });
      });
    },
    toggleClick(item) {
      item.toggleShow = !item.toggleShow;
    },
    async onLoad() {
      await dumpPost({
        url: this.url,
        page: this.page,
      })
        .then(res => {
          this.allPage = res.data.allPage;
          res.data.vctLayerInfo.map(item => {
            item.toggleShow = true;

            // 替换头像地址中的域名
            if (item.author && item.author.face) {
              if (item.author.face.indexOf('pm001.net') !== -1 || item.author.face.indexOf('kc0011.net') !== -1 || item.author.face.indexOf('xx007.cn') !== -1) {
                item.author.face = item.author.face.replace(/https?:\/\/[^\/]*?(pm001\.net|kc0011\.net|xx007\.cn)/gi, 'https://yichen.smartrecorder.xyz');
              }
            }

            // 替换勋章图片地址中的域名
            if (item.author && item.author.skin) {
              if (item.author.skin.indexOf('pm001.net') !== -1 || item.author.skin.indexOf('kc0011.net') !== -1 || item.author.skin.indexOf('xx007.cn') !== -1) {
                item.author.skin = item.author.skin.replace(/https?:\/\/[^\/]*?(pm001\.net|kc0011\.net|xx007\.cn)/gi, 'https://yichen.smartrecorder.xyz');
              }
            }

            let imgReg = /<img.*?(?:>|\/>)/gi;
            //筛选出所有的img
            let arr = item.content.match(imgReg);
            let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
            if (arr && arr.length > 0) {
              arr.map(it => {
                const src = it.match(srcReg);
                if (src && src[1]) {
                  let newSrc = src[1];
                  // 替换 pm001.net、kc0011.net 和 xx007.cn 域名为代理地址
                  if (newSrc.indexOf('pm001.net') !== -1 || newSrc.indexOf('kc0011.net') !== -1 || newSrc.indexOf('xx007.cn') !== -1) {
                    newSrc = newSrc.replace(/https?:\/\/[^\/]*?(pm001\.net|kc0011\.net|xx007\.cn)/gi, 'https://yichen.smartrecorder.xyz');
                  }
                  let newImg = it.replace(srcReg, `src="${newSrc}"`);
                  if (src[1].indexOf('gif') == -1) {
                    newImg = newImg.replace('<img', '<img style="display:block;width:100%" ');
                  }
                  item.content = item.content.replace(it, newImg);
                }
              });
            }
          });
          let tmpList = this.isSort
            ? res.data.vctLayerInfo
            : res.data.vctLayerInfo.sort((a, b) => b.layer - a.layer);
          let list = this.list || [];
          if (tmpList.length) {
            list = [...list, ...tmpList];
          } else {
            this.finished = true;
          }
          if ((this.isSort && this.page == res.data.allPage) || (!this.isSort && this.page == 1)) {
            this.finished = true;
          }
          this.loading = false;
          this.list = list;
          this.isSort && this.page++;
          !this.isSort && this.page--;
          this.topic = this.isSort ? this.list[0].topic : this.list[this.list.length - 1].topic;
          this.viewinfos.readCount = res.data.readCount || null;
          this.viewinfos.replyCount = res.data.replyCount || null;
          // this.$toast.clear();

          // 为新加载的图片添加预览功能
          this.addImagePreview();
        })
        .catch(error => {
          this.finished = true;
          this.loading = false;
        });
    },
    reply() {
      this.$router.push('/reply?type=1&url=' + encodeURIComponent(encodeURIComponent(this.url)));
    },
    handleScoreList(item) {
      let name = item.author.name;
      let t = item.author.creditScore;
      let userId = item.author.userId;
      this.$router.push(`/ratingList?type=1&url=${encodeURIComponent(encodeURIComponent(this.url))}&name=${name}&t=${t}&userId=${userId}`);
    },
    //评分
    handleScore(item) {
      console.log(item)
      let name = item.author.name;
      let t = item.author.creditScore;
      let userId = item.author.userId;
      this.$router.push(`/score?type=1&url=${encodeURIComponent(encodeURIComponent(this.url))}&name=${name}&t=${t}&userId=${userId}`);
    },
    lifeBuoy() {
      this.lifeBuoyShow = true;
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      let obj = {
        url: this.url,
        userName: userinfo.userName,
        passWord: userinfo.passWord,
        uuid: userinfo.uuid,
      };
      queryProps(obj).then(res => {
        this.isLifeBuoyShowFetch = true;
        this.lifeBuoyInfos = res.data;
      });
    },
    async save() {
      this.isVip = await asyncIsVip(2);
      if (!this.isVip) {
        return;
      }
      if (this.checkedCardNum == 13 && this.lifeBuoyInfos.lifeRingAmount == 0) {
        this.$toast('无此道具，暂时无法使用');
        return;
      }
      if (this.checkedCardNum == 14 && this.lifeBuoyInfos.bigLifeRingAmount == 0) {
        this.$toast('无此道具，暂时无法使用');
        return;
      }
      this.$toast.loading({
        message: '救生圈配置中,请稍等~',
        forbidClick: true,
        duration: 0,
      });
      this.isdisabled = true;
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      let obj = {
        propsType: this.checkedCardNum, //小救生圈：13  大救生圈：14
        url: this.url,
        userName: userinfo.userName,
        passWord: userinfo.passWord,
        uuid: userinfo.uuid,
      };
      useProps(obj).then(res => {
        this.$toast('使用成功');
        this.lifeBuoyShow = false;
        this.isdisabled = false;
        this.lifeBuoy();
      });
    },
    checkedCard(type) {
      switch (type) {
        case 13:
          this.smallqchecked = true;
          this.bigqchecked = false;
          this.checkedCardNum = 13;
          break;
        case 14:
          this.bigqchecked = true;
          this.smallqchecked = false;
          this.checkedCardNum = 14;
          break;
        default:
          break;
      }
    },
    getPlateinfos() {
      this.sectionCode = this.$route.query.section;
      let code = this.$route.query.section;
      let str = window.localStorage.getItem('plateList');
      if (JSON.parse(str) && JSON.parse(str).length > 1) {
        JSON.parse(str).map(item => {
          item.children.map(it => {
            if (it.code == code) {
              this.sectionName = `${item.name}->${it.name}`;
            }
          });
        });
      } else {
        getSectionList().then(res => {
          res.data.map(item => {
            item.children.map(it => {
              if (it.code == code) {
                this.sectionName = `${item.name}->${it.name}`;
              }
            });
          });
        });
      }

      // this.lifeBuoy();
    },
    back() {
      let item = this.$route.query;
      // 判断机型 ios/安卓
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      const el = isiOS ? document.documentElement : document.body;

      this.$route.meta.scrollHeight = el.scrollTop || el.scrollHeight;
      if (isiOS) {
        window.location.href = `${this.url}`;
      } else {
        this.$router.push({
          path: '/posts',
          query: {
            title: item.title,
            src: decodeURIComponent(decodeURIComponent(item.href)),
            type: item.type,
            author: item.author,
            date: item.lastupdatetime,
          },
        });
      }
    },
    thePoster() {
      //只看楼主
      console.log(this.$store.state.app.ycUserinfos);
      let name = JSON.parse(this.$store.state.app.ycUserinfos).userName;
      let r = this.list.filter(function (x) {
        return x.author.name == name;
      });
      this.list = r;
      console.log(r);
    },
    sort() {
      this.isSort = !this.isSort;
      this.list = [];
      this.page = this.isSort ? 1 : this.allPage;
      this.onLoad();
    },
    callPhone(content) {
      let arr = [];
      let str = content;
      var est = /\d{11}/g;
      var phoneArr = str.match(est);
      phoneArr.map(item => {
        var cox = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (cox.test(item) == true) {
          console.log(item);
          arr.push({ name: item });
        }
      });
      this.actions = arr;
      this.show = true;
    },
    onSelect(e) {
      window.location.href = 'tel://' + e.name;
    },
    returnBack() {
      window.history.back(-1);
    },
  },
  mounted() {
    let info = this.$route.query;
    let href = `${location.origin}/#/postView?date=${encodeURIComponent(
      info.date,
    )}&author=${encodeURIComponent(info.author)}&type=${encodeURIComponent(
      info.type,
    )}&href=${encodeURIComponent(encodeURIComponent(this.url))}&section=${encodeURIComponent(
      info.section,
    )}&title=${encodeURIComponent(info.title)}`;
    console.log(info);
    console.log(href);
    setTimeout(function () {
      wx.ready(function () {
        let res = `${cardType(info.type)} ${info.date ? shareformatDateTime(info.date) : ''}\r\n`;
        let author = info.type == 4 && info.author ? `作者：${info.author}\r\n` : '';
        let descText = IsPC() ? '' : res + author + '公众号[一尘盯盘助手]';

        console.log(descText);
        wx.updateAppMessageShareData({
          title: info.title, // 分享标题
          desc: descText, // 分享描述
          link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function () {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title: info.title, // 分享标题
          desc: descText, // 分享描述
          link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function () {
            // 设置成功
          },
        });
      });
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
.postView {
  padding-bottom: 240px;
  box-sizing: border-box;

  .head {
    width: 100%;
    font-size: 14px;
    color: rgba(56, 56, 56, 1);
    opacity: 1;
    background: linear-gradient(180deg, rgba(161, 196, 253, 1) 0%, rgba(194, 233, 251, 1) 100%);
    padding: 14px 10px;
    display: flex;
    justify-content: space-between;

    img {
      width: 18px;
      height: 18px;
    }
  }

  .label {
    font-size: 13px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(0deg, rgba(72, 198, 239, 1) 0%, rgba(111, 134, 214, 1) 100%);
    // border: 0.3px solid rgba(229, 229, 229, 1);
    padding: 8px;
  }

  .infos {
    padding: 9px 15px 10px 15px;
    box-sizing: border-box;
    background: rgba(229, 229, 229, 1);
    border: 0.3px solid rgba(229, 229, 229, 1);

    .s1 {
      display: flex;
      justify-content: space-between;

      .t {
        display: flex;
        align-items: center;
        flex: 1;

        .tx {
          width: 30px;
          height: 30px;
          display: block;
          border-radius: 50%;
          margin-right: 5px;
        }

        .name {
          font-size: 12px;
          font-weight: 500;
          color: rgba(120, 145, 67, 1);
        }

        .xj {
          display: block;
          margin-left: 5px;
        }
      }
    }

    .s2 {
      margin-top: 10px;

      .row {
        display: flex;
        padding: 3px 0;

        .f {
          flex: 1;
          color: rgba(56, 56, 56, 1);
          font-size: 12px;
          text-align: left;
          display: flex;
          align-items: baseline;

          .slabel {
            display: block;
            min-width: 55px;
          }

          .cdesc {
            display: block;
          }
        }
      }
    }

    .rbtn {
      display: flex;
      color: rgba(42, 130, 228, 1);
      font-size: 12px;
      text-decoration-line: underline;

      div {
        margin-right: 5px;
      }
    }
  }

  .layer {
    position: absolute;
    right: 0;
    top: -3px;
    color: #333;
    font-size: 15px;
  }

  .downLoadApp {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    font-size: 14px;
    background: #c55168;
    color: #fff;

    .dlIMG {
      display: block;
      width: 18px;
      height: 18px;
      margin-left: 10px;
    }
  }

  .html {
    padding: 0 17px;
    font-size: 14px;
    min-height: 200px;
    padding: 20px;

    .htmlcontent {
      min-height: 100px;

      a {
        img {
          display: block;
          width: 100%;
        }
      }
    }

    .desc {
      font-size: 10px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 14.37px;
      color: rgba(128, 128, 128, 1);
      position: relative;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }

    .toggleBtn {
      position: absolute;
      right: 0;
      top: 7px;
      font-size: 15px;
      color: #333;
    }

    .hideDescbox {
      display: block;
    }

    .sigline {
      margin-top: 20px;
      display: block;
      width: 100%;
      margin-bottom: 5px;
    }
  }

  .storey {
    opacity: 1;
    background: linear-gradient(0deg, rgba(161, 196, 253, 1) 0%, rgba(194, 233, 251, 1) 100%);
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    color: #333;
    align-items: center;
    height: 4px;

    // padding: 6px 11px;
    .ip {
      width: 12px;
      height: 16px;
      display: inline-block;
      margin-right: 10px;
    }

    .top {
      width: 16px;
      height: 13px;
      display: inline-block;
    }
  }

  .lifebuoyBox {
    .head {
      font-size: 16px;
      color: #fff;
      text-align: center;
      background: linear-gradient(0deg, rgba(72, 198, 239, 1) 0%, rgba(111, 134, 214, 1) 100%);
    }

    .content {
      display: flex;
      padding: 20px;

      .card {
        flex: 1;
        border-radius: 5px;
        background: rgba(229, 229, 229, 1);
        border: 1px solid rgba(229, 229, 229, 1);
        padding: 15px;
        padding-bottom: 10px;

        img {
          width: 120px;
          display: block;
        }

        &:first-child {
          margin-right: 10px;
        }

        .checked {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          padding-top: 5px;
          box-sizing: border-box;
        }
      }

      .active {
        background: rgba(255, 235, 59, 1);
      }
    }

    .bottomtip {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 19.21px;
      color: rgba(56, 56, 56, 1);
      text-align: left;
      padding-left: 20px;
    }
  }

  .btnsave {
    margin-top: 20px;
  }
}
</style>
